<template>
  <el-dialog
    title="修改公司信息"
    :visible.sync="dialogFormEditCompanyInfo"
    class="form-loading"
    :modal-append-to-body="false"
  >
    <el-form
      :model="form"
      ref="form"
      :rules="rules"
      label-width="110px"
      @close="close"
      label-position="left"
    >
      <el-form-item label="办公地址：" prop="workAddress">
        <el-input v-model="form.workAddress"></el-input>
      </el-form-item>

      <el-form-item label="联系人姓名：" prop="contracter">
        <el-input v-model="form.contracter"></el-input>
      </el-form-item>

      <el-form-item label="联系电话：" prop="tel">
        <el-input v-model="form.tel"></el-input>
      </el-form-item>

      <el-form-item label="邮箱：" prop="email">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormEditCompanyInfo = false">取 消</el-button>

      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { ObjectAssignSingle } from '@/utils'
import { modifyFirstInfo } from '@/api/distributor-api'
import { OWNER_COMPANY_INFO_RULE } from '@/views/service/rules'
export default {
  props: {
    infoData: {
      require: true,
    },
  },
  components: {},
  mixins: [],
  data() {
    return {
      dialogFormEditCompanyInfo: false,
      form: {
        workAddress: '',
        contracter: '',
        tel: '',
        email: '',
      },
      rules: OWNER_COMPANY_INFO_RULE.call(this),
    }
  },
  watch: {
    infoData: {
      deep: true,
      handler() {
        this.copyInfoData()
      },
    },
  },
  computed: {},
  mounted() {},
  created() {},
  filters: {},
  methods: {
    // 显示弹窗
    showDialog() {
      this.dialogFormEditCompanyInfo = true
      this.copyInfoData()
    },
    // 数据回显
    copyInfoData() {
      ObjectAssignSingle(this.form, this.infoData)
      this.handParams()
    },
    // 关闭清空表单信息
    close() {
      this.$refs.form.resetFields()
    },
    // 提交校验
    submit() {
      let params = this.handParams()
      if (!params) {
        this.dialogFormEditCompanyInfo = false
        return false
      } else {
        this.$refs.form.validate((valid) => {
          if (valid) {
            let { distributorId, contractSubject } = this.infoData
            // 后端说这几个参数必传
            params.distributorId = distributorId
            params.contractSubject = contractSubject
            this.updateFirstInfo(params)
          } else {
            return false
          }
        })
      }
    },
    // 提交表单
    async updateFirstInfo(params) {
      await modifyFirstInfo(params)
      this.outMsg('success', '提交成功')
      this.dialogFormEditCompanyInfo = false
      this.$emit('submitSuccess')
    },
    handParams() {
      let { workAddress, contracter, tel, email } = this.form
      let params = {}
      if (workAddress !== this.infoData.workAddress) {
        params.workAddress = workAddress
      }
      if (contracter !== this.infoData.contracter) {
        params.contracter = contracter
      }
      if (tel !== this.infoData.tel) {
        params.tel = tel
      }
      if (email !== this.infoData.email) {
        params.email = email
      }
      let keys = Object.keys(params)
      if (keys.length > 0) {
        return params
      } else {
        return false
      }
    },
  },
}
</script>
